import { render, staticRenderFns } from "./leaseContractPage.vue?vue&type=template&id=2fb64aa2&scoped=true"
import script from "./leaseContractPage.vue?vue&type=script&lang=js"
export * from "./leaseContractPage.vue?vue&type=script&lang=js"
import style0 from "./leaseContractPage.vue?vue&type=style&index=0&id=2fb64aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb64aa2",
  null
  
)

export default component.exports